(function(){
if(window.__fzqf)return;window.__fzqf=1;
var IMG=window.FZQ_IMG,SLOGAN=window.FZQ_SLOGAN,D=window.FZQ,S=D.S,BEST=D.BEST,CAR=D.CAR,Q=D.Q,ph=D.ph,cut=D.cut,homeWaves=D.homeWaves;
var a={},idx=0,F=[],root=document.getElementById('fzqf'),body=document.getElementById('fzqf-body'),foot=document.getElementById('fzqf-foot'),cache={};
function flow(){
  var f=['where'],w=a.where;
  if(w==='car'){f.push('color','mood');return f}
  if(w==='room')f.push('place');
  if(w==='home')f.push('hvac');
  if(w==='biz')f.push('bsize');
  var direct=(w==='home'&&a.hvac==='yes')||w==='biz';
  if(!direct){f.push('size');if(a.size==='s'&&a.place!=='bath')f.push('style')}
  f.push('family','mood','avoid','intensity');return f;
}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function open(){root.classList.add('on');document.documentElement.style.overflow='hidden';a={};idx=-1;F=flow();welcome()}
function close(){root.classList.remove('on');document.documentElement.style.overflow='';if(location.hash==='#quiz')history.replaceState(null,'',location.pathname+location.search)}
/* wide banner (logo + home waves + white curve) shown on every quiz screen */
function buildTop(){
  var top=root.querySelector('.top');if(!top)return;
  var im=top.querySelector('.brand img'),src=im?im.getAttribute('src'):'';
  var cv='<svg class="waves" viewBox="0 0 1440 80" preserveAspectRatio="none" aria-hidden="true"><path fill="#ffffff" d="M0 58 C260 36 520 78 780 58 S1200 40 1440 60 V80 H0 Z"><animate attributeName="d" dur="16s" repeatCount="indefinite" values="M0 58 C260 36 520 78 780 58 S1200 40 1440 60 V80 H0 Z;M0 62 C260 80 520 40 780 60 S1200 76 1440 58 V80 H0 Z;M0 58 C260 36 520 78 780 58 S1200 40 1440 60 V80 H0 Z"/></path></svg>';
  top.innerHTML='<button class="x" type="button" aria-label="Close" data-x>&times;</button><div class="brand"><img src="'+src+'" alt="Fraganzza"></div>'+homeWaves('fzqht','fz-hw')+cv;
}
buildTop();
function welcome(){
  foot.hidden=true;root.classList.add('wl');
  var logo=document.querySelector('#fzqf .brand img'),w=document.querySelector('#fzqf .top .waves');
  var wv=w?w.outerHTML:'';
  var bg=IMG.welcome?' style="background-image:linear-gradient(115deg,rgba(37,44,71,.85),rgba(37,44,71,.35)),url('+IMG.welcome+');background-size:cover;background-position:center"':'';
  body.innerHTML='<div class="wh"'+bg+'>'+homeWaves('fzqhw','wr')+'<button class="x" type="button" aria-label="Close" data-x>&times;</button><img class="wlogo" src="'+(logo?logo.src:'')+'" alt="Fraganzza"><div class="wt"><div class="t">Find your signature scent</div><p>A few questions. A scent that feels like you.</p><button class="btn" type="button" data-start>Discover my scent</button></div><div class="wi" id="fzqf-wi"></div>'+wv+'</div><div class="steps"><div><b>1</b>Your space</div><div><b>2</b>Your style</div><div><b>3</b>Your match</div></div><img class="slogan" src="'+SLOGAN+'" alt="">';
  Promise.all([product('table-top-diffuser'),product('hilton')]).then(function(r){
    return Promise.all(r.map(function(p){return p&&p.featured_image?cut(p.featured_image):null}))
  }).then(function(u){var el=document.getElementById('fzqf-wi');if(!el)return;el.innerHTML=(u[0]?'<img class="wd" src="'+esc(u[0])+'" alt="">':'')+(u[1]?'<img class="wb" src="'+esc(u[1])+'" alt="">':'')});
}
function step(){
  root.classList.remove('wl');F=flow();var k=F[idx],q=Q[k];foot.hidden=false;
  var cur=a[k],multi=q.multi,html='<h2>'+esc(q.t)+'</h2><p class="hint">'+esc(q.h||'')+'</p>';
  function isSel(v){return multi?(cur||[]).indexOf(v)>-1:cur===v}
  if(q.chips){html+='<div class="chips">'+q.o.map(function(o){return'<button type="button" class="chip'+(isSel(o[0])?' sel':'')+'" data-v="'+o[0]+'">'+esc(o[1])+'</button>'}).join('')+'</div>'}
  else if(q.rows){html+='<div class="rows">'+q.o.map(function(o){return'<button type="button" class="row'+(isSel(o[0])?' sel':'')+'" data-v="'+o[0]+'"><b>'+esc(o[1])+'</b><small>'+esc(o[2]||'')+'</small></button>'}).join('')+'</div>'}
  else{html+='<div class="grid" style="--cols:'+q.cols+'">'+q.o.map(function(o){return'<button type="button" class="card'+(isSel(o[0])?' sel':'')+'" data-v="'+o[0]+'"><div class="ph" style="'+ph(o[3])+'"></div><b>'+esc(o[1])+'</b>'+(o[2]?'<small>'+esc(o[2])+'</small>':'')+'</button>'}).join('')+'</div>'}
  if(q.skip)html+='<button type="button" class="skip" data-skip>'+esc(q.skip)+'</button>';
  body.innerHTML=html;
  var pct=Math.round(idx/(F.length)*100);
  document.getElementById('fzqf-pct').textContent=pct+'% complete';document.getElementById('fzqf-bar').style.width=pct+'%';
  nextState();document.querySelector('#fzqf .scroll').scrollTop=0;
}
function nextState(){var k=F[idx],v=a[k],ok=Q[k].multi?(v&&v.length>0)||v==='skip':!!v;var b=document.querySelector('#fzqf [data-next]');b.disabled=!ok;b.innerHTML=(idx===F.length-1?'Finish':'Next')+' &rsaquo;'}
function pick(v){
  var k=F[idx],q=Q[k];
  if(q.multi){var c=a[k];if(!Array.isArray(c))c=[];var i=c.indexOf(v);if(i>-1)c.splice(i,1);else if(c.length<q.multi)c.push(v);a[k]=c}
  else{a[k]=v}
  step();
}
function go(d){
  if(d>0){idx++;F=flow();if(idx>=F.length){results();return}step()}
  else{if(idx<=0){idx=-1;welcome();return}idx--;step()}
}
/* ---------- results ---------- */
function product(h){if(cache[h])return cache[h];return cache[h]=fetch('/products/'+h+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})}
function money(c){return'$'+(c/100).toFixed(c%100?2:0)}
function deviceHandle(){
  var w=a.where;
  if(w==='car')return'ultrasonic-car-diffuser';
  if(w==='home'&&a.hvac==='yes')return'hvac-diffuser';
  if(w==='biz')return a.bsize==='s'?'table-top-diffuser':a.bsize==='m'?'wall-diffuser':'hvac-diffuser';
  if(a.size==='l')return'wall-diffuser';
  if(a.size==='m')return'table-top-diffuser';
  if(a.place==='bath')return'mini-wall-diffuser';
  return a.style==='wall'?'mini-wall-diffuser':'mini-table-top-diffuser';
}
var DEVNOTE={'ultrasonic-car-diffuser':'Auto on/off · up to 210 cu ft','mini-table-top-diffuser':'100–500 sq ft · compact','mini-wall-diffuser':'200–600 sq ft · wall mounted','table-top-diffuser':'Up to 1,000 sq ft · Bluetooth app','wall-diffuser':'1,000–10,000 sq ft · Bluetooth app','hvac-diffuser':'Up to 16,000 sq ft · whole-home system'};
var INTL=['','●○○ Soft','●●○ Moderate','●●● Intense'];
function isCozy(s){return s[5]===1||s[2].split(',').indexOf('cozy')>-1}
function rank(){
  var fam=(a.family&&a.family!=='skip')?a.family:[],avoid=(a.avoid&&a.avoid!=='skip')?a.avoid:[],inten=parseInt(a.intensity||'2',10),mo=a.mood;
  var month=new Date().getMonth(),cold=(month>=9||month<=2);
  var list=[];
  S.forEach(function(s){
    var has=s[6].split(','),bad=false;
    avoid.forEach(function(v){if(v==='strong'){if(s[4]===3)bad=true}else if(has.indexOf(v)>-1)bad=true});
    if(bad)return;
    if(s[5]===1&&!cold&&fam.indexOf('cozy')<0)return;
    var p=0,sf=s[2].split(',');
    fam.forEach(function(f){if(sf.indexOf(f)>-1)p+=3});
    if(s[3].split(',').indexOf(mo)>-1)p+=3;
    var d=Math.abs(s[4]-inten);p+=d===0?2:d===1?1:0;
    if(BEST.indexOf(s[0])>-1)p+=1;
    if(cold&&isCozy(s))p+=2;
    list.push([p,s]);
  });
  list.sort(function(x,y){return y[0]-x[0]});
  var out=list.map(function(x){return x[1]});
  var need=fam.indexOf('cozy')>-1?2:(cold?1:0);
  if(need){
    var cz=out.filter(function(s){return s[2].split(',').indexOf('cozy')>-1||(cold&&s[5]===1)});
    var coz=out.filter(function(s){return s[2].split(',').indexOf('cozy')>-1});
    var pickz=(coz.length>=need?coz:cz).slice(0,need);
    var rest=out.filter(function(s){return pickz.indexOf(s)<0});
    out=rest.slice(0,3-need).concat(pickz,rest.slice(3-need));
  }
  return out;
}
function results(){
  root.classList.remove('wl');
  foot.hidden=true;document.getElementById('fzqf-bar').style.width='100%';
  body.innerHTML='<h2>Finding your match…</h2>';
  var dh=deviceHandle();
  var isCar=a.where==='car';
  var cands=isCar?[]:rank().slice(0,12);
  Promise.all([product(dh),isCar?product('ultrasonic-car-refill'):Promise.resolve(null)].concat(cands.map(function(s){return product(s[0])}))).then(function(r){
    var dev=r[0],refill=r[1],prods=r.slice(2);
    if(dev&&!dev.available&&dh==='wall-diffuser'){return product('table-top-diffuser').then(function(t){render(t,dh,refill,cands,prods,true)})}
    render(dev,dh,refill,cands,prods,false);
  });
}
function colorVariant(p){
  var want=a.color||'Black';var v=p.variants.filter(function(x){return x.available});
  var m=v.filter(function(x){return(x.option1||'').toLowerCase()===want.toLowerCase()||(x.title||'').toLowerCase().indexOf(want.toLowerCase())>-1})[0];
  return m||v[0]||p.variants[0];
}
function varImg(p,v){
  if(v&&v.featured_image&&v.featured_image.src)return v.featured_image.src;
  if(v&&v.featured_media&&v.featured_media.preview_image&&v.featured_media.preview_image.src)return v.featured_media.preview_image.src;
  var w=(a.color||'').toLowerCase();var im=(p.images||[]).filter(function(s){return w&&s.toLowerCase().indexOf(w)>-1})[0];
  return im||p.featured_image||'';
}
function render(dev,dh,refill,cands,prods,swapped){
  var h='<h2>Your scent, your space.</h2><p class="hint">A personalized selection for you.</p><div class="res">';
  if(swapped)dh='table-top-diffuser';
  if(dev){
    var v=colorVariant(dev),img=varImg(dev,v);
    h+='<div class="lab">Your diffuser</div><div class="dev"><img src="'+esc(img)+'" alt=""><div><h3>'+esc(dev.title.split(' – ')[0])+(a.color?' · '+esc(a.color):'')+'</h3><p>'+esc(DEVNOTE[dh]||'')+' · '+money(v.price)+'</p><div class="acts" style="justify-content:flex-start"><button class="btn" type="button" data-add="'+v.id+'">Add to cart</button><a class="btn ghost" href="/products/'+dh+'?variant='+v.id+'">View</a></div></div></div>';
  }
  var items=[];
  if(a.where==='car'&&refill){
    var pool=CAR.map(function(c){var p=0;if(c[2].split(',').indexOf(a.mood)>-1)p+=3;return[p,c]}).sort(function(x,y){return y[0]-x[0]}).slice(0,3);
    items=pool.map(function(x){var vv=refill.variants.filter(function(z){return z.title===x[1][0]})[0];return{name:x[1][1],img:(vv&&vv.featured_image&&vv.featured_image.src)||refill.featured_image,url:'/products/ultrasonic-car-refill'+(vv?'?variant='+vv.id:''),note:'Car refill'}});
  }else{
    for(var i=0;i<cands.length&&items.length<3;i++){var p=prods[i];if(!p||!p.available)continue;var v2=p.variants.filter(function(z){return z.title==='120 ml'&&z.available})[0]||p.variants.filter(function(z){return z.available})[0];var pr=v2?'From '+money(Math.min.apply(null,p.variants.filter(function(z){return z.available}).map(function(z){return z.price}))):'';items.push({name:cands[i][1],img:p.featured_image,url:'/products/'+cands[i][0],note:INTL[cands[i][4]]+(isCozy(cands[i])?' · Cozy':'')+(pr?'<br>'+pr:'')})}
  }
  if(items.length){h+='<div class="lab">Your scents</div><div class="three">'+items.map(function(it){return'<div class="sc"><img src="'+esc(it.img||'')+'" alt=""><b>'+esc(it.name)+'</b><small>'+it.note+'</small><a class="btn ghost" href="'+it.url+'">View scent</a></div>'}).join('')+'</div>'}
  h+='<div class="samp"><img src="" alt="" id="fzqf-sampimg"><div><b>Not familiar with our scents?</b><span>Try the Samples Box with the Mini Air before you buy.</span></div><a class="btn ghost" href="/products/samples">Samples Box</a></div>';
  h+='<div class="acts"><button class="btn ghost" type="button" data-again>Start over</button></div></div>';
  body.innerHTML=h;
  product('samples').then(function(s){var im=document.getElementById('fzqf-sampimg');if(im&&s)im.src=s.featured_image});
  document.querySelector('#fzqf .scroll').scrollTop=0;
}
function addToCart(id,btn){
  btn.disabled=true;btn.textContent='Adding…';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})}).then(function(r){if(!r.ok)throw 0;btn.textContent='Added ✓';var c=document.createElement('a');c.className='btn ghost';c.href='/cart';c.textContent='View cart';btn.parentNode.appendChild(c)}).catch(function(){btn.disabled=false;btn.textContent='Add to cart'});
}
root.addEventListener('click',function(e){
  var t=e.target.closest('button,a');if(!t)return;
  if(t.hasAttribute('data-x'))return close();
  if(t.hasAttribute('data-start')){idx=0;return step()}
  if(t.hasAttribute('data-back'))return go(-1);
  if(t.hasAttribute('data-next')){if(!t.disabled)go(1);return}
  if(t.hasAttribute('data-again'))return open();
  if(t.hasAttribute('data-add'))return addToCart(t.getAttribute('data-add'),t);
  if(t.hasAttribute('data-skip')){a[F[idx]]='skip';return go(1)}
  if(t.hasAttribute('data-v')){var k=F[idx];pick(t.getAttribute('data-v'));
    if(!Q[k].multi){clearTimeout(window.__fzqt);window.__fzqt=setTimeout(function(){if(root.classList.contains('on')&&F[idx]===k)go(1)},320)}}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('on'))close()});
document.addEventListener('click',function(e){var l=e.target.closest&&e.target.closest('a[href]');if(!l||root.contains(l))return;var h=l.getAttribute('href')||'';if(/#quiz$/.test(h)){e.preventDefault();e.stopImmediatePropagation();open()}},true);
if(location.hash==='#quiz')setTimeout(open,400);
window.addEventListener('hashchange',function(){if(location.hash==='#quiz')open()});
})();